import {constants} from '@newsela/angelou';
import {css} from 'emotion';

import uiColors from 'static/three-oh/src/components/Colors/colors';
import fonts from 'static/three-oh/src/modules/constants/fonts';

const colors = constants.colors;

const leftAndRightPadding = 25;

const suggestionList = css`
  list-style-type: none;
  padding: 0;
`;

const header = css`
  width: 100%;
  font-family: Circular, Helvetica, Arial, sans-serif;
  font-size: ${fonts.sizes.xs};
  color: ${constants.colors.ui.greyLight[700]};
  padding: 15px ${leftAndRightPadding}px 7px ${leftAndRightPadding}px;
  font-weight: normal;
`;

const suggestion = css`
  display: block;
  list-style-type: none;
  width: 100%;
  max-width: 670px;
  padding: 5px ${leftAndRightPadding}px;
  color: ${colors.ui.grey[700]};
  font-size: ${fonts.sizes.m};
  line-height: 2;
  font-family: Circular, Helvetica, Arial, sans-serif;
  margin: 10px 0px;

  &:hover {
    cursor: pointer;
    background-color: ${colors.ui.greyExtraLight['700']};
    color: ${colors.ui.greyDark[700]};
  }
`;

const standardSuggestion = css`
  ${suggestion};
  margin: 15px 0px;
  line-height: 1.4;
  padding: 9px ${leftAndRightPadding}px;

  &:hover {
    font-weight: normal;
  }
`;

const mobileStandardSuggestion = css`
  line-height: 40px;
`;

const standardDescriptionRow = css`
  display: flex;
  justify-content: space-between;
  font-size: ${fonts.sizes.s};
  margin-bottom: 7px;
`;

const standardTitle = css`
  color: ${uiColors.dark_green[0]};
`;

const divider = css`
  border-top: 1px solid ${colors.ui.greyLight[500]};
  margin: 0px ${leftAndRightPadding}px 0 ${leftAndRightPadding}px;
`;

export default {
  divider,
  suggestionList,
  header,
  suggestion,
  standardSuggestion,
  standardDescriptionRow,
  standardTitle,
  mobileStandardSuggestion,
};
